import Home from "./Home";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import PostPage from "./PostPage";
import Application from "./Application";
import PostDetail from "./PostDetail";
import Layout from "./Layout";
import LoginPage from "./Login";
import AuthorPage from "./author/AuthorPage";
import Search from "./Search";
import SingleGallery from "./Photos/single-gallery";
import SportsPosts from "./Categories/Sports";
import CategoryPage from "./Categories/CategoryPage";
import AboutUs from "./AboutUs/AboutUs";
import ErrorPage from "./ErrorPage";
import ScrollToTop from "./ScrollToTop";
import Gallery from "./Photos/gallery";

export default function App() {
  document.title = "The Spectrum";

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />}></Route>
          <Route path="/post/:slug" element={<PostDetail />}></Route>
          <Route path="/articles" element={<PostPage />}></Route>
          <Route path="/apply" element={<Application />}></Route>
          <Route path="/login" element={<LoginPage />}></Route>
          <Route path="/author/:authorSlug" element={<AuthorPage />}></Route>
          <Route path="/search/:searchTerm" element={<Search />}></Route>
          <Route path="/sports" element={<SportsPosts />}></Route>
          <Route path="/category/:category" element={<CategoryPage />}></Route>
          <Route path="/about-us" element={<AboutUs />}></Route>
          <Route path="/gallery" element={<Gallery />}></Route>
          <Route
            path="/gallery/:gallerySlug"
            element={<SingleGallery />}
          ></Route>
          <Route path="*" element={<ErrorPage />}></Route>
        </Route>
      </Routes>
    </Router>
  );
}
